module.exports = __webpack_public_path__ + "static/media/s-home_formats_conference.201632ed.jpg";